import { fromJS, Map } from 'immutable'
import { setLocalStorage } from '../../../services/local-preferences/index'
import { setAiGa4Event } from '../../../services/event-tracking/actions'
import { AI_RECOMMENDATION_CLICKED_GA4_EVENT } from '../../../services/event-tracking/index'
import { RelatedDocument } from '../MediaTile'

/**
 * Builds the event data object for AI recommendation tracking
 * @param document - The related document to track
 * @returns Immutable Map with event data in snake_case format
 */
export function buildAiRecommendationEventData (document: RelatedDocument) {
  return fromJS({
    content_id: document.contentId,
    content_type: document.contentType,
    content_name: document.title,
    parent_series_name: document.parentSeriesName || null,
    parent_series_id: document.parentSeriesId || null,
    media_id: document.mediaId || null,
    media_language: document.mediaLanguage || null,
    is_featured_media: document.isFeaturedMedia ?? false,
  })
}

/**
 * Tracks AI recommendation click event and stores document info in localStorage
 * @param document - The related document that was clicked
 * @param dispatch - Redux dispatch function
 * @param auth - Auth state from Redux (Immutable Map)
 */
export function trackAiRecommendationClick (
  document: RelatedDocument,
  dispatch: (action: { type: string; payload?: unknown }) => void,
  auth: Map<string, unknown>,
) {
  const eventData = buildAiRecommendationEventData(document)
  dispatch(setAiGa4Event(AI_RECOMMENDATION_CLICKED_GA4_EVENT.mergeDeep(eventData)))

  // Store document info in localStorage for click attribution
  const uid = auth.get('uid')
  setLocalStorage('ai_video_clicked', { path: document.path }, uid, auth)
}
